import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { getLeaderboardConfig, leaderboardConfigEntity } from '../../service/leaderboard';
import { GameLeaderboardCategory } from './GameLeaderboardCategory';

interface GameLeaderBoardProps {
    gameId: string;
}

export const GameLeaderBoard: React.FC<GameLeaderBoardProps> = ({ gameId }) => {
    const [lbData, setlbData] = useState<leaderboardConfigEntity[]>([]);
    const { keycloak } = useKeycloak();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const lbConfig = await getLeaderboardConfig(gameId, keycloak.token);
                setlbData(lbConfig.global);
            } catch (err: any) {
                console.error(err);
            }
        };
        fetchData();
    }, [gameId]);

    return (
        <Box>
            <Tabs>
                <TabList>
                    {lbData.map((lb) => (
                        <Tab className="leaderboard-tab" key={lb.leaderboardName}>
                            <Text>{lb.displayName}</Text>
                        </Tab>
                    ))}
                </TabList>
                <TabPanels>
                    {lbData.map((lb) => (
                        <TabPanel className="leaderboard-tab-panel" key={lb.leaderboardName}>
                            <GameLeaderboardCategory gameID={gameId} leaderboardConfig={lb} />
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Box>
    );
};
